import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ResourcesService, Research } from "../api";
import { ResearchReportRenderer } from "../components/chat/ResearchReportRenderer";

const ResearchDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [research, setResearch] = useState<Research | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      fetchResearch(id);
    }
  }, [id]);

  const fetchResearch = async (researchId: string) => {
    setLoading(true);
    try {
      const data = await ResourcesService.researchRetrieve(researchId);
      setResearch(data);
      setError(null);
    } catch (err) {
      console.error("Error fetching research:", err);
      setError("Failed to load the research report. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="scientia-container">
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error || !research) {
    return (
      <div className="scientia-container">
        <div className="form-message is-error" role="alert">
          {error || "Research report not found"}
        </div>
        <Link to="/resources" className="button is-outlined">
          ← Back to Resources
        </Link>
      </div>
    );
  }

  return (
    <div className="scientia-container">
      <div className="research-detail">
        <div className="research-detail__header">
          <Link to="/resources" className="back-link">
            ← Back to Resources
          </Link>
          <h1 className="title">Web Research Report</h1>
          <p className="subtitle">
            {research.query} • {formatDate(research.created)}
          </p>
        </div>

        <div className="scientia-card">
          <div className="scientia-card__content">
            <div className="research-content">
              <ResearchReportRenderer
                reportData={JSON.stringify(research.report)}
                context="standalone"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResearchDetailPage;
